import React from 'react';
import { Box, Typography, Link, useTheme, useMediaQuery } from '@mui/material';
import { Trans } from '@lingui/react/macro';
import { RetroTheme } from '../types/theme';

const Footer: React.FC = () => {
  const theme = useTheme() as RetroTheme;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        padding: 2,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        borderTop: `1px solid ${theme.palette.primary.main}`,
        boxShadow: `0 0 5px ${theme.custom.glowPrimary}`,
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        flexShrink: 0, // Prevent footer from shrinking
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: theme.palette.primary.main,
          textAlign: 'center',
        }}
      >
        © {currentYear} <Trans id="footer.copyright">OTS_Analytics</Trans>
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: theme.palette.primary.main,
          textAlign: 'center',
          display: isMobile ? 'none' : 'block',
        }}
      >
        |
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: theme.palette.primary.main,
          textAlign: 'center',
        }}
      >
        <Trans id="footer.poweredBy">
          Powered by{' '}
          <Link
            href="https://otarchive.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: theme.palette.primary.main,
              '&:hover': {
                color: theme.palette.primary.light,
                textDecoration: 'underline',
              }
            }}
          >
            OT Archive
          </Link>{' '}
          &{' '}
          <Link
            href="https://otservlist.com.br"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: theme.palette.primary.main,
              '&:hover': {
                color: theme.palette.primary.light,
                textDecoration: 'underline',
              }
            }}
          >
            OTServList Brasil
          </Link>
        </Trans>
      </Typography>
    </Box>
  );
};

export default Footer;
